import { render, staticRenderFns } from "./DrawInvoice.vue?vue&type=template&id=745a44bf&scoped=true"
import script from "./DrawInvoice.vue?vue&type=script&lang=js"
export * from "./DrawInvoice.vue?vue&type=script&lang=js"
import style0 from "./DrawInvoice.vue?vue&type=style&index=0&id=745a44bf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a44bf",
  null
  
)

export default component.exports